import { createFileRoute, useSearch } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { ProcessingCanvas } from '@/features/app-shell/canvases/processing-canvas'

type ClipProcessingSearch = {
  taskId: string
  src?: string
  title?: string
  style?: string
  language?: string
  orientation?: string
  resolution?: string
}

export const Route = createFileRoute('/app/clip-processing')({
  validateSearch: (search: Record<string, unknown>): ClipProcessingSearch => ({
    taskId: typeof search.taskId === 'string' ? search.taskId : '',
    src: typeof search.src === 'string' ? search.src : undefined,
    title: typeof search.title === 'string' ? search.title : undefined,
    style: typeof search.style === 'string' ? search.style : undefined,
    language: typeof search.language === 'string' ? search.language : undefined,
    orientation: typeof search.orientation === 'string' ? search.orientation : undefined,
    resolution: typeof search.resolution === 'string' ? search.resolution : undefined,
  }),
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: ClipProcessingRoute,
})

function ClipProcessingRoute() {
  const search = useSearch({ from: '/app/clip-processing' })
  return (
    <ProcessingCanvas
      taskId={search.taskId}
      videoTitle={search.title}
      videoSrc={search.src}
      style={search.style}
      language={search.language}
      orientation={search.orientation}
      resolution={search.resolution}
    />
  )
}
